/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Container,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../components/pageTitle/PageTitle";
import ThemeTable from "../../../components/Table/ThemeTable";
import CommonContext from "../../../hooks/commonContext";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router";
import { getAllEmployee } from "../../../services/apiservices/employee";
import AuthContext from "../../../hooks/authContext";
import { packageAccess } from "../../../services/helpers";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { Edit, Plus, Search, UserPlus } from "lucide-react";
import styles from "../users.module.scss";
import SingleSelect from "../../../components/SelectField/SingleSelect";
import { Badge } from "../../../components/ui/badge";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import { Input } from "../../../components/ui/input";

const AccountDetails = (props) => {
  const { allEmps, companyId, userLimit, redirectToCreateAdmin } = props;
  const companyData = allEmps?.filter(
    (item) => item?.id === companyId && item?.role === "companyUser"
  );
  // const adminData = allEmps?.filter(
  //   (item) =>
  //     item?.companyId === companyId && item?.role === "admin" && !item.deleted
  // );
  const adminData = allEmps?.filter((item) => {
    const roles = Array.isArray(item?.role) ? item?.role?.map((r) => r.toLowerCase()) : [item?.role?.toLowerCase()];
    return item?.companyId === companyId && roles.includes("admin") && !item.deleted;
  });
  const empData = allEmps?.filter((item) => {
    const roles = Array.isArray(item?.role) ? item?.role?.map((r) => r.toLowerCase()) : [item?.role?.toLowerCase()];
    return (
      item?.companyId === companyId && !item.deleted && (!roles.includes("admin") || roles.includes("employee"))
    );
  });
  // const empData = allEmps?.filter(
  //   (item) =>
  //     item?.companyId === companyId && item?.role !== "admin" && !item.deleted
  // );

  return (
    <Card className="mb-6 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardHeader className="p-24">
        <div className={props?.isMobile ? "d-flex flex-direction-column" : "d-flex flex-space-between w-100"}>
          <CardTitle className="text-xl">Manage Admin</CardTitle>
          {/* <Button
            style={{ backgroundColor: "#16A34A", color: "white" }}
            onClick={() => redirectToCreateAdmin()}
          >
            <UserPlus className="h-5 w-5 mr-10" />
            <span>Add New Admin</span>
          </Button> */}
        </div>
      </CardHeader>
      <CardContent className="pt-0 ph-24 pb-24">
        <div className="space-y-4">
          <div className="p-12 bg-white rounded border shadow-sm dark:bg-[#1A1F2C] dark:border-none">
            <div className="grid grid-cols-2 gap-y-3">
              <div className="text-gray-500">Company:</div>
              <div className="font-medium text-right">
                {companyData?.[0]?.companyName}
              </div>

              <div className="text-gray-500">Active Users:</div>
              <div className="font-medium text-blue-600 dark:text-blue-400 text-right">
                {(empData?.length ?? 0) + (companyData?.length ?? 0)}
              </div>

              <div className="text-gray-500">System Admins:</div>
              <div className="font-medium text-blue-600 dark:text-blue-400 text-right">
                {adminData?.length ?? 0}
              </div>

              <div className="text-gray-500">Company Manager:</div>
              <div className="font-medium text-blue-600 dark:text-blue-400 text-right">
                {companyData?.[0]?.firstName}{" "}
                {companyData?.[0]?.lastName
                  ? ` ${companyData[0].lastName}`
                  : ""}
              </div>

              <div className="text-gray-500">Remaining User Limit:</div>
              <div className="font-medium text-right">
                {userLimit -
                  ((empData?.length ?? 0) +
                    (companyData?.length ?? 0))}
              </div>

              <div className="text-gray-500">User Limit (Company Package):</div>
              <div className="font-medium text-right">{userLimit}</div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const ManageAdmin = (props) => {
  const commonContext = useContext(CommonContext);
  const history = useNavigate();
  const auth = useContext(AuthContext);
  const [allAdmins, setAllAdmins] = React.useState();
  const [allEmps, setAllEmps] = React.useState();
  const [searchTerm, setsearchTerm] = React.useState("");
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [isLoading, setIsLoading] = React.useState(false);
  const [roles, setRoles] = useState("All");
  const companyId =
    auth?.userProfile?.role === "superUser"
      ? null
      : auth?.userProfile?.role === "companyUser"
      ? auth?.userProfile?.id
      : auth?.userProfile?.companyId;
  const pkgId = auth?.userProfile?.prdId;
  const userPromocode = auth?.userProfile?.userPromoCode || auth?.userProfile?.companyData?.userPromoCode;
  const subscriptionId = auth?.userProfile?.subscriptionDetails?.scheduleId || auth?.userProfile?.subscriptions?.data?.[0]?.scheduleId;
  const allowedPermissions = packageAccess(pkgId, userPromocode, subscriptionId);
  const UsersLimits =
    allowedPermissions?.userLimit + auth?.userProfile?.additionalQuantity;
  const userLimit =
    pkgId === "prod_RvDCcqf57eCBxS" ? auth?.userProfile?.quantity : UsersLimits;

  const Columns = [
    {
      id: "employeeName",
      numeric: false,
      disablePadding: true,
      label: "Name",
      isSortable: true,
    },
    {
      id: "email",
      numeric: false,
      disablePadding: true,
      label: "Email",
      isSortable: true,
    },
    {
      id: "contactNumber",
      numeric: false,
      disablePadding: true,
      label: "Contact",
      isSortable: true,
    },
    {
      id: "company",
      numeric: false,
      disablePadding: true,
      label: "Company",
      isSortable: true,
    },
    {
      id: "role",
      numeric: false,
      disablePadding: true,
      label: "Role",
      isSortable: true,
    },
    {
      id: "action",
      numeric: false,
      disablePadding: true,
      label: "Action",
      rowclassName: "text-right",
      className: "text-right pr-30",
    },
  ];

  const roleOptions = [
    { label: "All Users", value: "All" },
    { label: "Sys. Admin", value: "Sys. Admin" },
    { label: "Team Admin", value: "Team Admin" },
    { label: "Company Manager", value: "companyManager" },
    { label: "Employee", value: "Employee" },
    { label: "Client", value: "Client" },
    { label: "Support", value: "Support" },
    { label: "Support User", value: "superUser" },
  ];

  const fetchUserList = async () => {
    setIsLoading(true);
    try {
      let data = [];
      await getAllEmployee((res) => {
        data = res?.data || [];
        setAllEmps(data);
      });

      if (data.length) {
        const Id =
          auth.userProfile.role === "companyUser"
            ? auth.userProfile.id
            : auth.userProfile.companyId;
        const isSuperUser = auth.userProfile.role === "superUser";

        const { companyUsers, admins } = data.reduce(
          (acc, item) => {
            if (item.role === "companyUser") acc.companyUsers.push(item);
            else if (!item.deleted) acc.admins.push(item);
            return acc;
          },
          { companyUsers: [], admins: [] }
        );

        const filterEmpData = isSuperUser
          ? admins
          : admins.filter((item) => item.companyId === Id);
        const filterCompanyData = isSuperUser
          ? companyUsers
          : companyUsers.filter((item) => item.id === Id);

        const companyMap = new Map(
          filterCompanyData.map((user) => [
            user.id,
            user.companyName || `${user.firstName} ${user.lastName}` || "—",
          ])
        );

        const mapRoles = (role) => {
          if (Array.isArray(role)) {
            return role.map((r) => {
              if (r === "admin") return "Sys. Admin";
              if (r === "companyUser") return "companyManager";
              return r;
            });
          } else {
            if (role === "admin") return ["Sys. Admin"];
            if (role === "companyUser") return ["companyManager"];
            return [role];
          }
        };

        const mapEmployeeRole = (role, employeerole) => {
          const hasEmployee = (Array.isArray(role) && role?.includes("Employee")) || role === "Employee";
          if (!hasEmployee) return null;
          return employeerole === "Admin" ? "Team Admin" : employeerole;
        };


        const adminData = filterEmpData?.map((adminItem) => ({
          ...adminItem,
          employeeName: `${adminItem.firstName} ${adminItem.lastName}`,
          contactNumber: adminItem.phoneNumber,
          company: companyMap.get(adminItem.companyId) || null,
          role: mapRoles(adminItem.role),
          employeerole: mapEmployeeRole(adminItem.role, adminItem.employeerole),
        }));

        const companyUserData = !isSuperUser
          ? filterCompanyData.map((user) => ({
              ...user,
              employeeName: `${user.firstName} ${user.lastName}`,
              contactNumber: user.phoneNumber,
              company: user.companyName,
              role: mapRoles(user.role),
              employeerole: mapEmployeeRole(user.role, user.employeerole),
            }))
          : [];

        const setalladminData = [...adminData, ...companyUserData].sort(
          (a, b) => {
            if (a.role === "Sys. Admin" && b.role !== "Sys. Admin") return -1;
            if (a.role !== "Sys. Admin" && b.role === "Sys. Admin") return 1;

            if (a.role === "companyManager" && b.role !== "companyManager")
              return -1;
            if (a.role !== "companyManager" && b.role === "companyManager")
              return 1;

            return 0;
          }
        );

        setAllAdmins(setalladminData);
      }
    } catch (error) {
      console.error("Error fetching user list:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUserList();
  }, []);

  const redirectToCreateAdmin = (adminId) => {
    if (typeof adminId !== "undefined" && adminId !== "")
      history("/account/createUserAdmin/" + adminId);
    else history("/account/createUserAdmin");
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    switch (hcellItem.id) {
      case "employeeName":
        return (
          <span
            style={{ fontSize: "16px", fontWeight: "500" }}
          >
            {rcellItem?.employeeName}
          </span>
        );
      case "email":
        return (
          <>
            <a
              href={`https://mail.google.com/mail/?view=cm&fs=1&to=${
                rcellItem[hcellItem?.id]
              }`}
              rel="noopener noreferrer"
              target="_blank"
              className="resLinks"
              style={{ overflowWrap: "anywhere" }}
            >
              {rcellItem[hcellItem?.id]}
            </a>
          </>
        );
      case "role":
        return (
          <>
            <div className="flex flex-wrap gap-1">
              {Array.isArray(rcellItem?.role) ? ( rcellItem.role?.map((r) => r === "Employee" ? rcellItem?.employeerole || "Employee" : r)?.filter(Boolean)?.map((r, index) => (
                <span key={index} className={`px-2 py-1 rounded-full text-xs ${
                     r === "Sys. Admin" || r === "Team Admin" ? "bg-green-100 text-green-800" : r === "companyManager" || r === "Client Team" ? "bg-blue-100 text-blue-800" : "bg-gray-100 text-gray-800"}`}>
                      {r}
                    </span>
                  ))
              ) : (
                <span className={`px-2 py-1 rounded-full text-xs ${(Array.isArray(rcellItem?.role) && rcellItem?.role?.includes("Sys. Admin")) || rcellItem?.employeerole === "Team Admin"
                      ? "bg-green-100 text-green-800" : (Array.isArray(rcellItem?.role) && rcellItem?.role === "companyManager") || rcellItem?.employeerole === "Client Team" ? "bg-blue-100 text-blue-800" : "bg-gray-100 text-gray-800"}`}>
                  {rcellItem?.role === "Employee" ? rcellItem?.employeerole || "Employee" : rcellItem?.role}
                </span>
              )}
            </div>
            {/* {rcellItem?.role === "Employee"  && (
              <span
                className={`px-2 py-1 ml-10 rounded-full text-xs ${
                  rcellItem?.employeerole === "Admin"
                    ? "bg-green-100 text-green-800"
                    : rcellItem?.employeerole === "Client Team"
                    ? "bg-blue-100 text-blue-800"
                    : "bg-gray-100 text-gray-800"
                }`}
              >
                {rcellItem?.employeerole}
              </span>
            )} */}
          </>
        );
      case "action":
        return (
          <>
              <Button
                color="primary"
                size="small"
                onClick={() => redirectToCreateAdmin(rcellItem?.id)}
              >
                <Edit size={18} />
              </Button>
          </>
        );

      default:
        return rcellItem[hcellItem?.id];
    }
  };

  const checkRowSearch = (searchTerm, row) => {
    return (
      String(row.employeeName)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.company)
        .toLowerCase()
        .includes(String(searchTerm).toLowerCase()) ||
      String(row.email).toLowerCase().includes(String(searchTerm).toLowerCase())
    );
  };

  const filteredList = allAdmins?.filter((item) => {
    const matchesSearch =
      searchTerm !== "" ? checkRowSearch(searchTerm, item) : true;

      const matchRoles =
        roles === "All" || roles === "" ? true : (Array.isArray(item?.role) ? item.role.includes(roles) : item?.role === roles) || item?.employeerole === roles;

    return matchesSearch && matchRoles;
  });

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Manage Administration"
          showBreadcrumb={[
            { label: "Home", to: "/" },
            { label: "Account" },
          ]}
          BreadCrumbCurrentPageTitle={"Administration"}
          showLastSeen={true}
          buttonTitle="Create System Admin"
          icons={<Plus className="h-4 w-4 mr-5" />}
          buttonClass={"d-flex flex-center"}
          buttonStyle={{
            color: "white",
            backgroundColor: "#16A34A",
            padding: "8px 16px",
            borderRadius: "5px",
          }}
          buttonClick={() => redirectToCreateAdmin()}
        />
        <div className={isMobile ? "ph-16 pv-24" : "ph-32 pv-24"}>
          <div style={{ borderRadius: "8px" }}>
            {auth?.userProfile?.role !== "superUser" && (
              <AccountDetails
                allEmps={allEmps}
                companyId={companyId}
                userLimit={userLimit}
                redirectToCreateAdmin={redirectToCreateAdmin}
                isMobile={isMobile}
              />
            )}
          </div>

          <div
            className={`sectionBox2 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:text-white`}
            // style={{
            //   borderRadius: "8px",
            //   border: "1px solid hsl(214.3, 31.8%, 91.4%)",
            // }}
          >
            <div
              className={
                isMobile
                  ? "d-flex flex-direction-column"
                  : "d-flex flex-space-between mb-20"
              }
            >
              <div className={styles.searchFieldWrapper}>
                <Search className={styles.searchIcon} />
                <Input
                  placeholder="Search team members..."
                  className="pl-40 bg-white dark:bg-[#0F1729]"
                  value={searchTerm ? searchTerm : ""}
                  onChange={(event) => {
                  setsearchTerm(event.target.value);
                  }}
                />
              </div>
              <div
                style={{ width: isMobile ? "365px" : "200px" }}
                className={isMobile ? "mv-10" : "mh-8"}
              >
                <SingleSelectNew
                  className={`field w-100`}
                  name={"selectStatus"}
                  contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                  itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                  value={roles}
                  onChange={(e) => setRoles(e)}
                  options={roleOptions}
                />
              </div>
            </div>
            {!isMobile && (
              <ThemeTable
                rows={filteredList}
                headCells={Columns}
                hidePagination={true}
                isLoading={isLoading}
                renderRowCell={renderRowCell}
              />
            )}
            {isMobile &&
              (filteredList?.length > 0
                ? filteredList?.map((user) => (
                    <Card key={user?.id} className="mb-16 w-100">
                      <CardContent className="pt-16 pb-24 ph-24">
                        <div className="flex justify-between items-start mb-12">
                          <div>
                            <h3 className="font-medium">
                              {user?.employeeName}
                            </h3>
                            <p className="text-sm text-blue-600">
                              <a
                                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${user?.email}`}
                                rel="noopener noreferrer"
                                target="_blank"
                                className="resLinks"
                                style={{ overflowWrap: "anywhere" }}
                              >
                                {" "}
                                {user?.email}
                              </a>
                            </p>
                          </div>
                          <div className="d-flex flex-direction-column">
                          <Badge
                            className={`
                            ${(Array.isArray(user?.role) && user?.role?.includes("Sys. Admin")) ||user?.employeerole === "Team Admin" ? "bg-green-100 text-green-800"
                              : (Array.isArray(user?.role) && user?.role === "companyManager") || user?.employeerole === "Client Team" ? "bg-blue-100 text-blue-800"
                              : "bg-gray-100 text-gray-800"
                            }`}
                          >
                            {Array.isArray(user?.role) ? user.role?.map((r) => (r === "Employee" ? user?.employeerole || "Employee" : r))?.filter(Boolean)?.join(", ") : user?.role === "Employee" ? user?.employeerole || "Employee" : user?.role}
                          </Badge>
                          {/* {user?.role === "Employee" && (
                            <Badge
                            className={
                              user?.employeerole === "Admin"
                              ? "bg-green-100 text-green-800 mt-8"
                              : user.employeerole === "Client Team"
                              ? "bg-blue-100 text-blue-800 mt-8"
                              : "bg-gray-100 text-gray-800 mt-8"
                            }
                            >
                            {user?.employeerole}
                          </Badge>
                          )} */}
                          </div>
                        </div>

                        <div className="space-y-2 text-sm">
                          {user?.contactNumber && (
                            <div className="flex justify-between">
                              <span className="text-gray-500">Contact:</span>
                              <span>{user?.contactNumber}</span>
                            </div>
                          )}

                          <div className="flex justify-between">
                            <span className="text-gray-500">Company:</span>
                            <span>{user?.company}</span>
                          </div>
                        </div>
                          <div className="mt-4 flex justify-end">
                            <Button
                              variant="ghost"
                              className="text-green-600 hover:text-green-800 hover:bg-green-50 h-8 w-8 p-0"
                              onClick={() => redirectToCreateAdmin(user?.id)}
                            >
                              <Edit size={18} />
                            </Button>
                          </div>
                      </CardContent>
                    </Card>
                  ))
                : null)}
          </div>
        </div>
      </Container>
    </>
  );
};
export default ManageAdmin;
